{
  "version": 1,
  "asset_id": "458452cc-fbb5-4f98-a799-b353d50fdf80",
  "project_id": "ede4779f-2e7a-461a-91d6-654024119c69",
  "url": "/__l5e/assets-v1/458452cc-fbb5-4f98-a799-b353d50fdf80/dzien-dobry-poster.webp",
  "r2_key": "a/v1/ede4779f-2e7a-461a-91d6-654024119c69/458452cc-fbb5-4f98-a799-b353d50fdf80/dzien-dobry-poster.webp",
  "original_filename": "dzien-dobry-poster.webp",
  "size": 31936,
  "content_type": "image/webp",
  "created_at": "2026-09-30T11:50:12Z"
}
